import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
import { IReviewState } from './state';

const state = (state: AppState) => state.reviewState;

export const review_DataSaved = createSelector(
  state,
  (state: IReviewState) => state.dataSaved
);